"use strict";

exports.__esModule = true;
exports["default"] = htmlAttributesAllowlistProps;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.map");

var _ariaAttributes = _interopRequireDefault(require("aria-attributes"));

var _htmlElementAttributes = _interopRequireDefault(require("html-element-attributes"));

var _possibleStandardNames = _interopRequireDefault(require("./possibleStandardNames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function htmlAttributesAllowlistProps(element, props) {
  if (props === void 0) {
    props = {};
  }

  if (!element) {
    return {};
  }

  var standardHtmlAttributes = _htmlElementAttributes["default"][element].concat(_ariaAttributes["default"]).concat(_htmlElementAttributes["default"]['*']);

  var reactHtmlAttributes = standardHtmlAttributes.map(function (attribute) {
    return _possibleStandardNames["default"][attribute] || attribute;
  });
  return Object.entries(props).filter(function (_ref) {
    var key = _ref[0];
    return reactHtmlAttributes.includes(key);
  }).reduce(function (accum, _ref2) {
    var _Object$assign;

    var key = _ref2[0],
        value = _ref2[1];
    return Object.assign({}, accum, (_Object$assign = {}, _Object$assign[key] = value, _Object$assign));
  }, {});
}